import { render, staticRenderFns } from "./ItinerarySectionItemNotes.vue?vue&type=template&id=c7f25bb8&scoped=true&"
import script from "./ItinerarySectionItemNotes.vue?vue&type=script&lang=js&"
export * from "./ItinerarySectionItemNotes.vue?vue&type=script&lang=js&"
import style0 from "./ItinerarySectionItemNotes.vue?vue&type=style&index=0&id=c7f25bb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f25bb8",
  null
  
)

export default component.exports